import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import { start } from '../config';

export default class AdvisoryToolStartView extends Component {
  componentDidMount() {
    this.props.advisoryResetCriteria();
    this.props.advisoryStartTool();
  }

  /* Render */

  render() {
    return (
      <div className="advisory-tool-wrapper">
        <div className="advisory-tool">
          <div className="offset">
            <div className="advisory-tool__image-header">
              <FormattedMessage tagName="h1" id="advisory.start.title" />
            </div>
          </div>
          <div className="offset offset--xl">
            <div className="advisory-tool__paragraph">
              <FormattedHTMLMessage id="advisory.start.info" />
            </div>
          </div>
          <div className="offset offset--xl u-text-center">
            <Link
              className="button button-bg-yellow advisory-tool__start-button"
              to={`/advisory-tool/${start.system}`}
            >
              <FormattedMessage id="advisory.start.action" />
            </Link>
          </div>
          <div className="offset offset--xl">
            <div className="advisory-tool__paragraph">
              <h2>
                <FormattedMessage id="advisory.start.consumerTitle" />
              </h2>
              <FormattedMessage id="advisory.start.savingInfo" />
            </div>
          </div>
          <div className="offset offset--xl u-text-center">
            <a
              className="button button-bg-yellow advisory-tool__start-button"
              href="https://remeha.nl/warmtewijzer"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FormattedMessage id="advisory.start.savingAction" />
            </a>
          </div>
          <div className="offset offset--xl">
            <div className="advisory-tool__paragraph">
              <FormattedMessage id="advisory.start.installerInfo" />
            </div>
          </div>
          <div className="offset offset--xl u-text-center">
            <a
              className="button button-bg-yellow advisory-tool__start-button"
              href="https://www.remeha.nl/locator/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FormattedMessage id="advisory.start.installerAction" />
            </a>
          </div>

          <div className="offset offset--xl">
            <div className="advisory-tool__paragraph">
              <h2>
                <FormattedMessage id="advisory.contentArea.what.title" />
              </h2>
              <FormattedMessage id="advisory.contentArea.what.content" values={{ lineBreak: <br /> }} />
            </div>
          </div>
          <div className="offset offset--xl u-text-center">
            <a
              className="button button-bg-yellow advisory-tool__start-button"
              href="https://www.remeha.nl/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <FormattedMessage id="advisory.contentArea.what.action" />
            </a>
          </div>
          <div className="offset offset--xl">
            <div className="advisory-tool__paragraph">
              <h2>
                <FormattedMessage id="advisory.contentArea.hybrid.title" />
              </h2>
              <FormattedMessage id="advisory.contentArea.hybrid.content" values={{ lineBreak: <br /> }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdvisoryToolStartView.propTypes = {
  advisoryStartTool: PropTypes.func,
  advisoryResetCriteria: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/views/advisory-tool/start/index.jsx